import { render, staticRenderFns } from "./koejakson-vaihe-hyvaksynnat.vue?vue&type=template&id=2c0349a8&scoped=true&"
import script from "./koejakson-vaihe-hyvaksynnat.vue?vue&type=script&lang=ts&"
export * from "./koejakson-vaihe-hyvaksynnat.vue?vue&type=script&lang=ts&"
import style0 from "./koejakson-vaihe-hyvaksynnat.vue?vue&type=style&index=0&id=2c0349a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0349a8",
  null
  
)

export default component.exports